import { ONE_WAY } from '@web-platform/shared-universal-constants/src/tripTypes';
import { shouldShowHotelsResults } from '@web-platform/shared-universal-utils-frontend/src/helpers/shouldShowHotelsResults';

import { getNumberOfNights } from '../selectors/numberOfNights';
import { getUserSearch } from '../state';

import type { StateType } from '@web-platform/shared-universal-types/src/redux/state/state-shared-types';

export const isValidSearchForHotels = (state: StateType): boolean => {
  const { tripType } = getUserSearch(state);
  const enableHotels = shouldShowHotelsResults();

  if (!enableHotels) {
    return false;
  }

  if (tripType !== ONE_WAY) {
    const numberOfNights = getNumberOfNights(state);

    // reject return flights of same-day
    if (numberOfNights < 1) {
      return false;
    }
  }

  return true;
};
